import Vue from 'vue'
import router from './router/index'
import store from './store/store'
import ConfigLoader from '@/helpers/config-loader'
import config from '@/config.js'

const baseUrl = ConfigLoader.get({
    config
}).rootUrl

const storeTokens = (response) => {
    const auth = store.state.auth
    // let user = store.state.user
    // user = response.body.user
    store.dispatch('setAuthTokens', Object.assign({}, {
        accessToken: response.body.accessToken,
        refreshToken: response.body.refreshToken
    }))
    store.dispatch('setUser', response.body.user)
}

const setAuthHeader = (request) => {
    request.headers.set('x-token', store.state.auth.accessToken)
    request.headers.set('x-refresh-token', store.state.auth.refreshToken)
}

const refreshTokensFromHeader = response => {
    store.dispatch('setAuthTokens', Object.assign({}, {
        accessToken: response.headers.get('x-token'),
        refreshToken: response.headers.get('x-refresh-token')
    }))
}

const refreshUser = (user) => {
    store.commit('user', user)
}

export default {
    install(Vue, options) {
        Vue.http.interceptors.push((request, next) => {
            // todo: refactoring remove nested auth object
            const token = store.state.auth.accessToken
            const hasAuthHeader = request.headers.has('x-token')
            if (token && !hasAuthHeader) {
                setAuthHeader(request)
            }

            next(response => {
                if (response.status === 401) {
                    store.dispatch('clearAuth')
                    router.push({
                        name: 'auth.login'
                    })
                }
                if (response.headers.has('x-token') && response.headers.has('x-refresh-token')) {
                    refreshTokensFromHeader(response)
                }
            })
        })

        Vue.prototype.$auth = Vue.auth = this
    },
    login(credentials, redirection) {
        return Vue.http.post(baseUrl + '/auth/login', credentials)
            .then(response => {
                storeTokens(response)
                if (redirection) {
                    router.push({
                        name: redirection
                    })
                }
            })
    },
    me() {
        const {
            accessToken,
            refreshToken
        } = store.state.auth
        if (!accessToken || !refreshToken) {

        } else {
            return Vue.http.get(baseUrl + '/api/user/me')
                .then(response => {
                    store.dispatch('setUser', response.body)
                })
        }
    },
    logout() {
        store.commit('clearAuth')
        router.push({
            name: 'auth.login'
        })
    }
}